var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_vm.show ? _c('div', {
    class: {
      _pop_mask: !_vm.hideMask
    },
    on: {
      "touchmove": function touchmove($event) {
        $event.preventDefault();
      }
    }
  }) : _vm._e(), _vm.show ? _c('div', {
    staticClass: "_pop _pop_qq",
    on: {
      "touchmove": function touchmove($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "pop_wrap"
  }, [_vm.title ? _c('div', {
    staticClass: "pop_title"
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm.showClose ? _c('i', {
    staticClass: "_pop_icon_cancel",
    attrs: {
      "data-role": "button"
    },
    on: {
      "click": _vm.close
    }
  }, [_c('svg', {
    staticClass: "_svg_icon_cancel",
    attrs: {
      "viewBox": "0 0 32 32"
    }
  }, [_c('path', {
    attrs: {
      "d": "M17.807 16.326l4.72 4.721c0.232 0.24 0.375 0.567 0.375 0.928 0 0.739-0.599 1.337-1.337 1.337-0.362 0-0.69-0.144-0.931-0.377l0 0-4.713-4.721-4.72 4.721c-0.24 0.233-0.569 0.377-0.931 0.377-0.739 0-1.337-0.599-1.337-1.337 0-0.361 0.143-0.688 0.375-0.929l-0 0 4.72-4.721-4.72-4.721c-0.232-0.24-0.375-0.568-0.375-0.928 0-0.739 0.599-1.337 1.337-1.337 0.362 0 0.69 0.144 0.931 0.377l4.72 4.721 4.713-4.721c0.24-0.233 0.569-0.377 0.931-0.377 0.739 0 1.337 0.599 1.337 1.337 0 0.361-0.143 0.688-0.375 0.929l0-0z"
    }
  })])]) : _vm._e(), _c('div', {
    staticClass: "pop_con"
  }, [_c('p', {
    staticClass: "txt",
    style: {
      textAlign: _vm.align
    },
    domProps: {
      "innerHTML": _vm._s(_vm.msg)
    }
  })]), _c('div', {
    staticClass: "v_btn_wrap cf"
  }, [_vm.type == 'confirm' ? _c('a', {
    staticClass: "v_btn v_btn_half",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.cancelClick
    }
  }, [_vm._v(_vm._s(_vm.cancelText))]) : _vm._e(), _c('a', {
    staticClass: "v_btn v_btn_em",
    class: {
      v_btn_half: _vm.type == 'confirm'
    },
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.confirmClick
    }
  }, [_vm._v(_vm._s(_vm.confirmText))])])])]) : _vm._e()]);
};
var staticRenderFns = [];
export { render, staticRenderFns };